import { BEDROOM_COUNTS } from 'shared/constants'
import { FilterSelector } from '../../presentations/FilterSelector'

interface BedroomsFilterContainerProps {
    open: boolean
    onOpen?: (event: any) => void
    onClose?: (event: any) => void
    onSelectedItemsChanged?: (event: any) => void
    initialSelectedItems: any[]
    propertyName?: string
}

export const BedroomsFilterContainer = (props: BedroomsFilterContainerProps): JSX.Element => {
    const {
        open,
        onOpen,
        onClose,
        propertyName,
        initialSelectedItems,
        onSelectedItemsChanged
    } = props

    return (
        <>
            <FilterSelector   
                text={'Bedrooms'}
                propertyName={propertyName}
                items={BEDROOM_COUNTS}
                initialSelectedItems={initialSelectedItems}
                open={open}
                onOpen={onOpen}
                onClose={onClose}
                onSelectedItemsChanged={onSelectedItemsChanged}
            />
        </>
    )
}